// Utility function to format time elapsed
export const formatTimeElapsed = (minutes: number): string => {
  if (minutes < 60) {
    return `${minutes}m`;
  } else if (minutes < 1440) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return remainingMinutes > 0
      ? `${hours}h ${remainingMinutes}m`
      : `${hours}h`;
  } else {
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
  }
};

// Utility function to format date
export const formatDateTime = (date: Date): string => {
  return new Date(date).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Utility function to normalize status
export const normalizeStatus = (
  status: any
): "healthy" | "stale" | "inactive" => {
  if (typeof status === "string") {
    const normalized = status.toLowerCase();
    if (normalized === "healthy") return "healthy";
    if (normalized === "stale") return "stale";
  }
  return "inactive"; // default fallback
};
